import React, {useEffect, useState} from 'react';
import {EnumPlanObdobi, PlanVO, StatistikaApi} from '../api';
import {PLAN, SKUTECNOST} from '../enums/PohledTypeEnum';
import {Col, Row, Spinner} from 'react-bootstrap';
import {DonutChartData} from '../types/DonutChartData';
import {DonutChart} from './DonutChart';
import {List} from './List';

interface StatistikaPanelProps {
    planObdobi: string;
    idVerze: string;
}

export const StatistikaPanel: React.FC<StatistikaPanelProps> = ({planObdobi, idVerze}) => {
    const [plans, setPlans] = useState<PlanVO[]>([]);
    const [fetching, setFetching] = useState(false);

    useEffect(() => {
        loadStatistika();
    }, [planObdobi, idVerze]);

    const loadStatistika = () => {
        const fetchData = async () => {
            let fPlans: PlanVO[] = [];
            try {
                setFetching(true);

                const obdobiEnum = planObdobi === PLAN ? EnumPlanObdobi.PLAN : EnumPlanObdobi.SKUTECNOST;
                fPlans = (await StatistikaApi.getStatistika(parseInt(idVerze), obdobiEnum)).data;
                setPlans(fPlans);

                setFetching(false);
            } catch (error) {
                // TODO
            }
        };
        fetchData();
    };

    if (fetching || plans.length === 0) {
        return (
            <div className="loading-data">
                <Spinner animation="border" role="status" style={{marginRight: 10}} />
                Načítání dat...
            </div>
        );
    }

    const koreny = plans.filter(item => item.idPlanOt === null);

    let charts = koreny.map(koren => {
        // @ts-ignore
        const chartData: DonutChartData[] = plans
            .filter(item => item.idPlanOt == koren.idPlan)
            .filter(item => item.castka !== 0 && item.castka !== null)
            .map(item => {
                return {value: item.castka === undefined ? 0 : Math.abs(item.castka) / 1000, type: item.nazevAkce, idPlan: item.idPlan};
            });
        return <DonutChart title={koren.nazevAkce ? koren.nazevAkce : ''} idVerze={idVerze} data={chartData} />;
    });

    return (
        <div style={{padding: 20}}>
            {charts.map((chart, index) => {
                let polozky = plans.filter(item => item.idPlanOt == koreny[index].idPlan);
                polozky = polozky.filter(item => item.castka !== 0 && item.castka !== null);
                return (
                    <div key={index}>
                        <h2>{koreny[index].nazevAkce}</h2>
                        <Row>
                            <Col xxl={6} lg={12}>
                                <List data={polozky} skutecnost={planObdobi === SKUTECNOST} />
                            </Col>
                            <Col xxl={6} lg={12}>
                                <div className="centered" key={index}>
                                    {chart}
                                </div>
                            </Col>
                        </Row>
                    </div>
                );
            })}
        </div>
    );
};
